import { useEffect, useState } from 'react';
import logo from '../../assets/images/logo.webp';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { Drawer, List, ListItem, IconButton, Stack, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { GoHome } from 'react-icons/go';
import { CiGrid41, CiUser, CiViewList } from 'react-icons/ci';
import { PiHeadsetLight } from 'react-icons/pi';
import { IoBagRemoveOutline } from 'react-icons/io5';
import { SECONDARY_COLOR } from '../../constants';

const navData = [
  {
    name: 'Home',
    path: '/',
    Icon: GoHome,
  },
  {
    name: 'Store',
    path: '/shop',
    Icon: CiGrid41,
  },
  {
    name: 'Support',
    path: '/contact-us',
    Icon: PiHeadsetLight,
  },
  {
    name: 'AMC',
    path: '/amc',
    Icon: CiViewList,
  },
  {
    name: 'Account',
    path: '/manage-account',
    Icon: CiUser,
  },
  {
    name: 'Cart',
    path: '/cart',
    Icon: IoBagRemoveOutline,
  },
];

export function NavbarDrawer() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  const navigate = useNavigate();

  const toggleDrawer =
    (open: boolean | undefined = undefined) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }
      if (open !== undefined) {
        setDrawerOpen(open);
      } else {
        setDrawerOpen((x) => !x);
      }
    };

  const handleNavigation = (path: string) => {
    navigate(path);
    setDrawerOpen(false);
  };

  return (
    <>
      <IconButton edge="start" color="inherit" aria-label="menu" onClick={toggleDrawer()}>
        <MenuIcon sx={{ fontSize: 35 }} />
      </IconButton>
      <Drawer
        ModalProps={{
          sx: {
            minWidth: '300px',
          },
        }}
        anchor="left"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
      >
        <div className="h-12" />
        <List sx={{ width: '300px', display: 'flex', flexDirection: 'column', gap: 2 }}>
          {navData.map(({ name, path, Icon }) => (
            <ListItem
              sx={{
                display: 'flex',
                gap: 2,
                borderBottom:
                  '1px solid ' + (location.pathname === path ? SECONDARY_COLOR : '#ccc'),
              }}
              key={name}
              component="button"
              onClick={() => handleNavigation(path)}
            >
              <Icon size={25} color="black" /> <Typography variant="body1">{name}</Typography>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
}

export default function Navbar() {
  const [loading, setLoading] = useState(true);
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const navigate = useNavigate();

  const navBarheight = loading ? 'h-screen justify-center' : 'h-12 justify-between',
    navbarBorder = isAuthenticated ? 'border-b-2 border-b-gray-400' : '';

  return (
    <>
      {
        <div
          className={` transition-all duration-500 ${navBarheight} ${navbarBorder} flex items-center gap-3 pl-3 pr-1 top-0 fixed w-full bg-white  container z-[9999] max-w-screen-sm`}
        >
          <Stack direction={'row'} alignItems={'center'}>
            {/* {isAuthenticated && (
              <div
                className={
                  loading ? 'delay-500 transition-all opacity-0 w-0' : 'delay-500 transition-all'
                }
              >
                <NavbarDrawer />
              </div>
            )} */}
            <div
              className="h-11 overflow-hidden flex items-center cursor-pointer"
              onClick={() => navigate('/')}
            >
              {/* {isAuthenticated && ( */}
                <img
                  alt="IFB"
                  src={logo}
                  className={
                    loading
                      ? 'delay-500 transition-all opacity-0 w-0'
                      : 'delay-500 transition-all h-[65%] z-[99999]'
                  }
                />
              {/* )} */}
              <img
                alt="IFB"
                src={logo}
                style={{zIndex: 99999999}}
                className={
                  !loading ? 'transition-all opacity-0 hidden' : 'm-auto transition-all h-[100%] '
                }
              />
            </div>
          </Stack>
          {/* <div
            className={loading ? 'delay-500 transition-all opacity-0' : 'delay-500 transition-all'}
          >
            {!loading && isAuthenticated && (
              <Stack direction={'row'}>
                <NavIcons />
              </Stack>
            )}
          </div> */}
        </div>
      }
    </>
  );
}
